<template>
    <PageTemplateContent>
        <BaseHero title="Frequently asked questions" />
        <BaseSection
            data-span-all
            section-width="content"
        >
            <BaseAccordion
                :items="[
                    {
                        title: 'What does the peer-review process entail?',
                        content: 'Uploaded video content will be reviewed by at least two independent experts in your field. Though you will remain responsible for the submitted work, they will check the quality, educational value, scientific integrity and patient anonymity.'
                    },
                    {
                        title: 'How does MedPeers protect privacy?',
                        content: `Patients should provide informed consent prior to the procedure. MedPEERS does not allow the use of patient-identifiable data. For more information, please have a look at our <a href='/legal/privacy'>privacy policy</a>.`
                    },
                    {
                        title: 'How is the security of the platform ensured?',
                        content: `MedPeers implements rigorous security measures to protect patients’ personal and medical data and adheres to strict (inter)national security standards. Please find more information on our <a href='/legal/security'>security and auditing</a> page.`
                    },
                    {
                        title: 'How do I create high quality video content?',
                        content: `MedPeers believes healthcare professionals are able to produce high quality and educational video content themselves. We have some tips and tricks to help you out, please have a look at our <a href='/how-to-make-a-video'>how to make a video</a> guide.`
                    },
                    {
                        title: 'How can I upload my video content?',
                        content: `Please find instructions on how to upload your video content on <a href='/upload'>our upload page</a>.`
                    },
                    {
                        title: 'Who will have access to my video?',
                        content: 'MedPeers is exclusively accessible to verified and licensed healthcare professionals.'
                    },
                    {
                        title: 'I want my video content to be removed from the MedPeers platform.',
                        content: `Please contact the MedPeers editorial office at <a href='mailto:support@medpeers.org'>support@medpeers.org</a>`
                    },
                    {
                        title: 'I’ve uploaded my video content. Can I still make any adjustments?',
                        content: `No, if changes to your uploaded video content are required please contact the MedPeers editorial office (<a href='mailto:support@medpeers.org'>support@medpeers.org</a>) for the removal of the initial version and make sure to upload the updated version.`
                    },
                    {
                        title: 'How can I support MedPeers?',
                        content: `The main intent of the MedPeers platform is to educate health care professionals all over the globe. To keep improving and expanding MedPeers relies on user donations and grants as well as early investors. If you’re interested, please send an email to <a href='mailto:support@medpeers.org'>support@medpeers.org</a>.`
                    },
                    {
                        title: 'How can I contact MedPeers?',
                        content: `For all other questions, please get in touch via <a href='mailto:support@medpeers.org'>support@medpeers.org</a>.`
                    }
                ]"
            />
        </BaseSection>
        <BentoFrame
            data-span-all
            class="content-width"
        >
            <h2>Do you have any other questions?</h2>
            <BaseButton
                element="a"
                href="mailto:support@medpeers.org"
            >
                Get in touch
            </BaseButton>
        </BentoFrame>
    </PageTemplateContent>
</template>

<script setup>
const { asset } = useBaseUrl();

useSeoMeta({
    title: 'MedPeers | Frequently asked questions',
    description: 'A secure, peer-reviewed and quality-controlled platform offering videos of medical procedures',
    ogImage: asset('/images/og/default.png')
});
</script>
